import { gql } from "@apollo/client"

export const ADD_GROWING_LINES = gql`
  mutation addGrowingLines($growingLines: [geo_location_insert_input!]!) {
    insert_geo_location(objects: $growingLines) {
      returning {
        id
        area_id
      }
    }
  }
`
